













import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

// import Breadcrumb from './Breadcrumb.vue';
import PageHeader from './PageHeader.vue';
import RoutView from '@/layouts/RouteView';

/** admin banner header */
@Component({ components: { PageHeader, RoutView } })
export default class AdminPage extends Vue {
  mounted() {}

  get contentCss() {
    return {
      margin: this.$route.meta.hiddenPageHeader === true ? '0' : '10px',
      'margin-left': this.$route.meta.hiddenPageHeader === true ? '1px' : '10px',
      'background-color': 'white',
      'border-radius': '3px',
    };
  }
}
